{
  "enum": {
    "IxcSweepsClearingV1OperationType": {
      "ACTIVITY_REPORT": "Activity Report",
      "BALANCES_RECONCILE": "Balances Reconcile",
      "DIVIDENDS_CALCULATE": "Dividends Calculate",
      "DIVIDENDS_PAY": "Dividends Pay",
      "DIVIDENDS_RECALCULATE": "Dividends Recalculate",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcSweepsClearingV1OrderType": {
      "PURCHASE": "Purchase",
      "REDEEM": "Redeem",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcSweepsClearingV1SweepOrderStatus": {
      "ACKED": "Acked",
      "CANCELED": "Canceled",
      "FAILED": "Failed",
      "POSTED": "Posted",
      "PROCESSING": "Processing",
      "SETTLED": "Settled",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcSweepsClearingV1SweepParticipantStatsStatus": {
      "ACTIVE": "Active",
      "FINALIZED": "Finalized",
      "PAID": "Paid",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcSweepsClearingV1SweepParticipantStatus": {
      "NOT_SWEEPING": "Not Sweeping",
      "SWEEPING": "Sweeping",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcSweepsClearingV1SweepTargetStatsStatus": {
      "UNSPECIFIED": "Unspecified",
      "VALID": "Valid"
    },
    "IxcSweepsClearingV1SweepsJobStatus": {
      "DONE": "Done",
      "OPEN": "Open",
      "PROCESSING": "Processing",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcSweepsClearingV1SweepsTaskStatus": {
      "ERRORED": "Errored",
      "FAILED": "Failed",
      "PENDING": "Pending",
      "SUCCEEDED": "Succeeded",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcSweepsClearingV1TaskUpdatedStatus": {
      "ERRORED": "Errored",
      "FAILED": "Failed",
      "PROCESSING": "Processing",
      "SUCCEEDED": "Succeeded",
      "UNSPECIFIED": "Unspecified"
    }
  },
  "filterEnum": {
    "IxcSweepsClearingV1SweepOrderQueryServiceSweepOrderListFilterableFields": {
      "data": {
        "accountId": "Account",
        "sweepTargetId": "Sweep Target"
      },
      "status": "Status",
      "sweepOrderId": "Sweep Order"
    },
    "IxcSweepsClearingV1SweepParticipantQueryServiceSweepParticipantListFilterableFields": {
      "accountId": "Account",
      "data": {
        "sweepPlanId": "Sweep Plan"
      },
      "status": "Status"
    },
    "IxcSweepsClearingV1SweepParticipantStatsQueryServiceSweepParticipantStatsListFilterableFields": {
      "accountId": "Account",
      "firstDayOfMonth": "First Day of Month",
      "status": "Status",
      "sweepTargetId": "Sweep Target"
    },
    "IxcSweepsClearingV1SweepTargetStatsQueryServiceSweepTargetStatsListFilterableFields": {
      "firstDayOfMonth": "First Day of Month",
      "status": "Status",
      "sweepTargetId": "Sweep Target"
    },
    "IxcSweepsClearingV1SweepsJobQueryServiceSweepsJobListFilterableFields": {
      "status": "Status",
      "sweepsJobId": "Job"
    },
    "IxcSweepsClearingV1SweepsTaskQueryServiceSweepsTaskListFilterableFields": {
      "accountId": "Account",
      "data": {
        "assetId": "Asset"
      },
      "status": "Status",
      "sweepTargetId": "Sweep Target",
      "sweepsJobId": "Job",
      "sweepsTaskId": "Task"
    }
  },
  "oneOf": {
    "IxcSweepsClearingV1CashBalanceEventSource": {
      "hold": "Hold",
      "transaction": "Transaction"
    },
    "IxcSweepsClearingV1Initiator": {
      "account": "Account",
      "cashBalance": "Cash Balance",
      "cashBalanceCatchUp": "Cash Balance Catch up",
      "hold": "Hold",
      "program": "Program",
      "reconcile": "Reconcile",
      "transaction": "Transaction"
    },
    "IxcSweepsClearingV1JobCreatedInfo": {
      "activityReport": "Activity Report",
      "balancesReconcile": "Balances Reconcile",
      "dividendsCalculate": "Dividends Calculate",
      "dividendsPay": "Dividends Pay",
      "dividendsRecalculate": "Dividends Recalculate"
    },
    "IxcSweepsClearingV1JobSpec": {
      "activityReport": "Activity Report",
      "balancesReconcile": "Balances Reconcile",
      "dividendsCalculate": "Dividends Calculate",
      "dividendsPay": "Dividends Pay",
      "dividendsRecalculate": "Dividends Recalculate"
    },
    "IxcSweepsClearingV1JobStats": {
      "activityReport": "Activity Report",
      "balancesReconcile": "Balances Reconcile",
      "dividendsCalculate": "Dividends Calculate",
      "dividendsPay": "Dividends Pay",
      "dividendsRecalculate": "Dividends Recalculate"
    },
    "IxcSweepsClearingV1JobTasksAddInfo": {
      "activityReport": "Activity Report",
      "balancesReconcile": "Balances Reconcile",
      "dividendsCalculate": "Dividends Calculate",
      "dividendsPay": "Dividends Pay",
      "dividendsRecalculate": "Dividends Recalculate"
    },
    "IxcSweepsClearingV1SweepOrderEventType": {
      "acked": "Acked",
      "canceled": "Canceled",
      "failed": "Failed",
      "posted": "Posted",
      "processing": "Processing",
      "settled": "Settled"
    },
    "IxcSweepsClearingV1SweepParticipantEventType": {
      "disabled": "Disabled",
      "enabled": "Enabled",
      "planChanged": "Plan Changed"
    },
    "IxcSweepsClearingV1SweepParticipantStatsEventType": {
      "finalized": "Finalized",
      "pay": "Pay",
      "paymentResult": "Payment Result",
      "paymentsCompleted": "Payments Completed",
      "updated": "Updated"
    },
    "IxcSweepsClearingV1SweepTargetStatsBatchEntryPayload": {
      "paid": "Paid",
      "updated": "Updated"
    },
    "IxcSweepsClearingV1SweepTargetStatsEventType": {
      "batchUpdated": "Batch Updated",
      "paid": "Paid",
      "updated": "Updated"
    },
    "IxcSweepsClearingV1SweepsJobEventType": {
      "allFinished": "All Finished",
      "closed": "Closed",
      "created": "Created",
      "sentinelReceived": "Sentinel Received",
      "taskUpdated": "Task Updated",
      "tasksAdd": "Tasks Add",
      "tasksBatchUpdated": "Tasks Batch Updated"
    },
    "IxcSweepsClearingV1SweepsTaskEventType": {
      "created": "Created",
      "errored": "Errored",
      "failed": "Failed",
      "finished": "Finished",
      "started": "Started"
    },
    "IxcSweepsClearingV1TaskCreatedInfo": {
      "activityReport": "Activity Report",
      "balancesReconcile": "Balances Reconcile",
      "dividendsCalculate": "Dividends Calculate",
      "dividendsPay": "Dividends Pay",
      "dividendsRecalculate": "Dividends Recalculate"
    },
    "IxcSweepsClearingV1TaskFinishedInfo": {
      "activityReport": "Activity Report",
      "balancesReconcile": "Balances Reconcile",
      "dividendsCalculate": "Dividends Calculate",
      "dividendsPay": "Dividends Pay",
      "dividendsRecalculate": "Dividends Recalculate"
    },
    "IxcSweepsClearingV1TaskSpec": {
      "activityReport": "Activity Report",
      "balancesReconcile": "Balances Reconcile",
      "dividendsCalculate": "Dividends Calculate",
      "dividendsPay": "Dividends Pay",
      "dividendsRecalculate": "Dividends Recalculate"
    },
    "IxcSweepsClearingV1TaskStartedInfo": {
      "activityReport": "Activity Report",
      "balancesReconcile": "Balances Reconcile",
      "dividendsCalculate": "Dividends Calculate",
      "dividendsPay": "Dividends Pay",
      "dividendsRecalculate": "Dividends Recalculate"
    },
    "IxcSweepsClearingV1TaskUpdatedData": {
      "activityReport": "Activity Report",
      "balancesReconcile": "Balances Reconcile",
      "dividendsCalculate": "Dividends Calculate",
      "dividendsPay": "Dividends Pay",
      "dividendsRecalculate": "Dividends Recalculate"
    }
  },
  "sortEnum": {
    "IxcSweepsClearingV1SweepOrderQueryServiceSweepOrderListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxcSweepsClearingV1SweepParticipantQueryServiceSweepParticipantListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxcSweepsClearingV1SweepParticipantStatsQueryServiceSweepParticipantStatsListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxcSweepsClearingV1SweepTargetStatsQueryServiceSweepTargetStatsListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxcSweepsClearingV1SweepsJobQueryServiceSweepsJobListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxcSweepsClearingV1SweepsTaskQueryServiceSweepsTaskListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    }
  }
}